/** The names the Azure pickers are registered under, shared by the registration and the validators. */
export const AZURE_SUBSCRIPTION_PICKER = 'AzureSubscriptionPicker';
export const AZURE_RESOURCE_GROUP_PICKER = 'AzureResourceGroupPicker';
export const AZURE_RESOURCE_PICKER = 'AzureResourcePicker';
